/* DM TELCO - LAUNCH READY (STABLE QUANTITY FIX) */

function isUserLoggedIn() {
  if (window.ShopifyAnalytics?.meta?.page?.customerId) return true;
  if (window.__st?.cid) return true;
  return false;
}

function getDmCustomHtml() {
  return `
    <div class="dm-custom-actions">
      <div class="dm-quantity-wrapper">
        <button type="button" class="dm-qty-btn" onclick="this.nextElementSibling.stepDown()">-</button>
        <input type="number" name="quantity" value="1" min="1" class="dm-qty-input">
        <button type="button" class="dm-qty-btn" onclick="this.previousElementSibling.stepUp()">+</button>
      </div>
      <button type="button" class="dm-boost-atc-btn" onclick="triggerBoostCart(this)">ADD TO CART</button>
    </div>
  `;
}

window.triggerBoostCart = function(btn) {
    const card = btn.closest('.boost-sd__product-item');
    if (!card) return;

    // Read quantity from the custom input, with fallback to 1
    const customQtyInput = card.querySelector('.dm-qty-input');
    const selectedQty = parseInt(customQtyInput?.value, 10) || 1;

    // Get the native Boost button
    const nativeBtn = card.querySelector('.boost-sd__button--select-option[data-metadata]');
    if (!nativeBtn) {
        console.error('DM: No native ATC button found in card', card);
        return;
    }

    // Parse variant ID from Boost's metadata
    let metadata;
    try {
        metadata = JSON.parse(nativeBtn.dataset.metadata);
    } catch (e) {
        console.error('DM: Could not parse metadata', e);
        return;
    }

    const variantId = String(metadata?.action?.addToCart?.productId || '');
    if (!variantId) {
        console.error('DM: No variantId in metadata', metadata);
        return;
    }

    // Capture the product title from the card so we can match the line in the drawer DOM later
    const titleEl = card.querySelector('.boost-sd__product-title, [class*="product-title"]');
    const productTitle = titleEl?.textContent?.trim() || '';

    console.log('DM: Adding via native click then patching qty to', selectedQty, 'for variant', variantId);

    // Step 1: Click the native Boost button. Adds 1 to cart, opens the drawer, updates the bubble.
    nativeBtn.click();

    // Step 2: Nothing more to do if the requested qty is 1.
    if (selectedQty === 1) return;

    // Step 3: Wait for the native add to land in the cart, then patch the line qty via Shopify Cart API.
    const startTime = Date.now();
    const maxWait = 5000;

    function pollAndPatch() {
        fetch('/cart.js', { credentials: 'same-origin' })
            .then(r => r.json())
            .then(cart => {
                const line = cart.items.find(item => String(item.variant_id) === variantId);

                if (!line) {
                    if (Date.now() - startTime > maxWait) {
                        console.error('DM: Timed out waiting for native add to land in cart');
                        return;
                    }
                    setTimeout(pollAndPatch, 150);
                    return;
                }

                // Native click already added 1. Add (selectedQty - 1) more on top of whatever was there.
                const targetQty = (line.quantity - 1) + selectedQty;
                const previousLineQty = line.quantity;

                console.log('DM: Patching line', line.key, 'from', line.quantity, 'to', targetQty);

                fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    credentials: 'same-origin',
                    body: JSON.stringify({ id: line.key, quantity: targetQty })
                })
                .then(r => r.json())
                .then(updatedCart => {
                    console.log('DM: Patch successful, cart now has', updatedCart.item_count, 'items');
                    syncDrawerDom(updatedCart, productTitle, targetQty, previousLineQty);
                })
                .catch(err => console.error('DM: Patch failed', err));
            })
            .catch(err => {
                console.error('DM: Cart poll failed', err);
            });
    }

    // Give the native click a brief head start before we start polling
    setTimeout(pollAndPatch, 200);
};

// Surgically updates Boost's open cart drawer to reflect the patched cart state.
// Boost paints the drawer optimistically after the native click and never re-queries
// Shopify, so we update the drawer DOM directly: header item count + the patched line's
// qty input. Other lines are already correct because Boost painted them from cache.
function syncDrawerDom(cart, productTitle, targetQty, previousLineQty) {
    const drawer = document.querySelector('.boost-sd__cart.boost-sd__cart--side');
    if (!drawer) {
        console.warn('DM: Drawer not open, skipping DOM sync');
        return;
    }

    // 1. Update header item count
    const header = drawer.querySelector('.boost-sd__cart-items-count');
    if (header) {
        const itemWord = cart.item_count === 1 ? 'item' : 'items';
        header.textContent = `Your cart (${cart.item_count} ${itemWord})`;
    }

    // 2. Find the line item in the drawer matching our product and update its qty input
    const lineItems = drawer.querySelectorAll('.boost-sd__cart-item');
    let matched = null;

    // Try matching by product title first
    if (productTitle) {
        const cleanTitle = productTitle.split('\n')[0].trim();
        lineItems.forEach(item => {
            const titleEl = item.querySelector('.boost-sd__cart-item-title');
            const itemTitle = titleEl?.textContent?.trim() || '';
            if (itemTitle.includes(cleanTitle)) matched = item;
        });
    }

    // Fallback: find the line whose qty input matches the pre-patch quantity
    if (!matched) {
        lineItems.forEach(item => {
            const inp = item.querySelector('.boost-sd__input-number-input');
            if (inp && parseInt(inp.value, 10) === previousLineQty) matched = item;
        });
    }

    if (!matched) {
        console.warn('DM: Could not find matching line in drawer to update');
        return;
    }

    const qtyInput = matched.querySelector('.boost-sd__input-number-input');
    if (qtyInput) {
        qtyInput.value = targetQty;
        // Also update any sibling display element Boost may use to show the qty
        const display = matched.querySelector('[class*="quantity-character"], [class*="quantity-display"]');
        if (display && /^\d+$/.test(display.textContent.trim())) display.textContent = targetQty;
        console.log('DM: Drawer line updated to qty', targetQty);
    }
}

function refreshSparkLayer() {
  document.dispatchEvent(new CustomEvent('spark-refresh-components'));
  window.dispatchEvent(new Event('resize'));
}

function fixProductCard(card) {
  if (!card.classList.contains('spark-product-card')) {
      card.classList.add('spark-product-card');
  }

  const isLoggedIn = isUserLoggedIn();
  const infoWrapper = card.querySelector('.boost-sd__product-info-wrapper');
  const nativePrice = card.querySelector('.boost-sd__product-price');
  const nativeButton = card.querySelector('.boost-sd__button');
  const nativeActions = card.querySelector('.boost-sd__product-item-actions');

  if (nativePrice && !nativePrice.dataset.formatted) {
      const priceMatch = nativePrice.innerText.match(/\$?[0-9,]+(?:\.\d+)?/);
      if (priceMatch) {
          let cleanPrice = priceMatch[0];
          if (!cleanPrice.includes('.')) cleanPrice += '.00';
          else if (/\.\d$/.test(cleanPrice)) cleanPrice += '0'; 
          nativePrice.innerHTML = cleanPrice;
      }
      nativePrice.dataset.formatted = "true"; 
  }

  if (isLoggedIn) {
    if (nativePrice) nativePrice.classList.add('dm-guest-hidden');
    if (nativeButton) nativeButton.classList.add('dm-guest-hidden');
    const customActions = card.querySelector('.dm-custom-actions');
    if (customActions) customActions.remove();
    return; 
  }

  if (nativePrice) nativePrice.classList.remove('dm-guest-hidden');
  if (nativeButton) nativeButton.classList.add('dm-guest-hidden');
  if (nativeActions) nativeActions.classList.add('dm-guest-hidden');

  if (infoWrapper && !card.querySelector('.dm-custom-actions')) {
    const customDiv = document.createElement('div');
    customDiv.innerHTML = getDmCustomHtml();
    infoWrapper.appendChild(customDiv);
  }
}

function centerSparkLayerPrice() {
  const cards = document.querySelectorAll('spark-product-card');
  cards.forEach(card => {
    if (card.shadowRoot && !card.shadowRoot.querySelector('#dm-price-center')) {
      const style = document.createElement('style');
      style.id = 'dm-price-center';
      style.textContent = `
        .sl-pricing-alignment, .sl-product-card-pricing-display {
          display: flex !important; justify-content: center !important; align-items: center !important;
          width: 100% !important; text-align: center !important; margin: 0 auto 10px auto !important;
        }
      `;
      card.shadowRoot.appendChild(style);
    }
  });
}

let sparkTimeout;
function watchForProducts() {
  const observer = new MutationObserver((mutations) => {
    let productsFound = false;
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          if (node.matches && node.matches('.boost-sd__product-item')) {
             fixProductCard(node);
             productsFound = true;
          }
          if (node.querySelectorAll) {
             const nested = node.querySelectorAll('.boost-sd__product-item');
             if (nested.length > 0) {
               nested.forEach(fixProductCard);
               productsFound = true;
             }
          }
        }
      });
    });
    if (productsFound) {
      clearTimeout(sparkTimeout);
      sparkTimeout = setTimeout(refreshSparkLayer, 500); 
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.boost-sd__product-item').forEach(fixProductCard);
    watchForProducts();
    setInterval(centerSparkLayerPrice, 250); 
  });
} else {
  document.querySelectorAll('.boost-sd__product-item').forEach(fixProductCard);
  watchForProducts();
  setInterval(centerSparkLayerPrice, 250); 
}